// This file is deprecated - use getSupabase() from @/lib/supabaseClient instead
// Keeping for backward compatibility but all new code should use the singleton

import { supabase as singletonSupabase } from "@/lib/supabaseClient";

// Re-export the singleton for backward compatibility
export const supabase = singletonSupabase;